
import { useEffect, useState, useRef } from 'react';

export default function EphemeralInfrastructure() {
  const [animated, setAnimated] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const features = [
    'Spin up per request',
    'Exist only for seconds',
    'Process entirely in RAM',
    'Terminate when complete',
    'Leave nothing behind',
  ];

  return (
    <section ref={sectionRef} className="relative py-24 bg-[#09090b]">
      <div className="max-w-[1200px] mx-auto px-6 sm:px-8">
        <h2 className="text-white text-3xl sm:text-[42px] font-black text-center mb-8 sm:mb-12">
          Ephemeral Infrastructure
        </h2>

        <div className="max-w-[900px] mx-auto space-y-8 sm:space-y-12">
          <p
            className={`text-[#d4d4d8] text-lg sm:text-xl leading-relaxed text-center transition-all duration-700 ${
              animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
            }`}
          >
            Traditional servers exist 24/7. Data accumulates. Attack surfaces expand.
          </p>

          <div className="space-y-4 sm:space-y-6">
            <p className="text-white text-xl sm:text-2xl font-bold text-center">
              HushLegal containers:
            </p>
            {features.map((feature, index) => (
              <div
                key={index}
                className={`flex items-center gap-3 sm:gap-4 p-4 sm:p-6 bg-[#0f0f11] border border-[#1a1a1c] rounded-lg transition-all duration-700 hover:border-[#06b6d4] hover:shadow-[0_0_30px_rgba(6,182,212,0.15)] ${
                  animated ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
                }`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <span className="text-[#06b6d4] text-xl sm:text-2xl">✓</span>
                <span className="text-white text-base sm:text-lg font-medium">{feature}</span>
              </div>
            ))}
          </div>

          <p
            className={`text-[#06b6d4] text-xl sm:text-2xl font-bold text-center pt-8 transition-all duration-700 delay-500 ${
              animated ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
            }`}
          >
            Your data is not deleted. It ceases to exist
          </p>
        </div>
      </div>
    </section>
  );
}
